import { localStorageColorSchemeManager } from '@mantine/core';

/** localStorage key for light / dark / auto preference. */
export const COLOR_SCHEME_STORAGE_KEY = 'falcon-planner-color-scheme';

export const appColorSchemeManager = localStorageColorSchemeManager({
  key: COLOR_SCHEME_STORAGE_KEY,
});
